import { render, staticRenderFns } from "./promocionesDestacadas.vue?vue&type=template&id=b5a064b2&scoped=true"
import script from "./promocionesDestacadas.vue?vue&type=script&lang=js"
export * from "./promocionesDestacadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a064b2",
  null
  
)

export default component.exports